<template>
  <KTCodePreview class="px-10" title="Request for OTP">
    <template v-slot:preview>
      <!-- overlay img-src="https://picsum.photos/900/250/?image=3" img-alt="Card Image" text-variant="white" -->
      <loading :active.sync="loading" opacity="0.9"></loading>

      <b-card-group deck>

        <b-card class="">
          <b-card-text>
            <b-row>
              <b-col cols="7" class="text-center" style="position:relative">
                <h3>Read me</h3>
                <div class="text-info font-weight-bold text-center w-100" style="position:absolute; top:30%">

                  <div class="py-1">
                    To set up 2-Step Verification, you need Google Authenticator app.
                  </div>
                  <div class="py-1">
                    Step 1. Open Google Authenticator app to scan the QR code below.
                  </div>
                  <div class="py-1">
                    Step 2. Enter the security code generated by Google Authenticator.
                  </div>
                </div>
              </b-col>
              <b-col cols="5" class="">

                <div class="text-center">
                  <vue-qrcode class="" style="width:200px !important;" :value="qrcode"></vue-qrcode>
                  <p>Scan this barcode</p>
                </div>
                <div class="text-center">
                  <b-form-group
                      label-for="input-formatter"
                      class="mb-0"
                  >
                    <b-form-input
                        autocomplete="off"
                        placeholder="Input Security Code" style=""
                        v-model="token"></b-form-input>
                  </b-form-group>
                </div>

              </b-col>
            </b-row>
          </b-card-text>

          <b-card-footer>
            <b-button @click="challenge" variant="primary" class="float-right" size="lg">Create Code</b-button>
          </b-card-footer>
        </b-card>
      </b-card-group>

    </template>
  </KTCodePreview>
</template>

<script>
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import KTCodePreview from "@/view/content/CodePreview.vue";
//import VueQrcode from 'vue-qrcode';
import VueQrcode from 'vue-qrcode'
import speakEasy from "speakeasy";
import { Auth } from 'aws-amplify';

export default {
  name: "SettingOTP",
  data() {

    return {
      user: null,
      token : "",
      qrcode : "",
      secret : "",
      loading : false,
    }
  },
  components : {
    KTCodePreview,
    VueQrcode
  },
  async mounted() {
    try{
      let auth = await Auth.currentAuthenticatedUser();
      console.log("auth", auth);
      this.user = auth.attributes;
      let secret
      if (this.user) {
        secret = speakEasy.generateSecret({length: 20, name: "Argos (" + this.user.email + ")"});
        console.log("secret", secret);
        this.secret = secret.ascii;
      }
      this.qrcode = secret.otpauth_url;
    }catch (e) {
      console.log("Error in mounted", e);
    }


    // await this.$store.dispatch(SET_BREADCRUMB, [
    //   { title: "Setting OTP" },
    // ]);
  },
  methods: {
    async challenge(){
      try{

        this.loading = true;

        let token = this.token;
        let secret = this.secret;

        let result = speakEasy.totp.verify({
          secret: secret,
          encoding: "ascii",
          token: token,
          window: 0
        });
        console.log("result", result);
        if( "boolean" === typeof result ) {

          //  incorrect otp code
          if( !result ) {
            this.$swal( {
              icon: 'error',
              text: 'Incorrect OTP Code.',
            });
            return ;
          }

          let params = {
            secret: secret,
            email: this.user.email
          };
          let setOtpValue = await this.$store.dispatch('createOtp', params);
          console.log("setOtpValue", setOtpValue);

          if(setOtpValue.statusCode == 200){
            this.$swal( {
              icon: 'success',
              text: 'OTP generation completed'
            }).then( () => {
              //성공 시 콜백
              // this.$session.clear();
              window.location = "/";
              // window.location.reload();
            } );
          }
          else{
            this.$swal( {
              icon: 'error',
              text: 'OTP generation failed',
            });
          }

        }
      }
      catch (e) {
        console.log("Error in challenge", e);
      }
      finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>

</style>
